var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-header',{attrs:{"title":_vm.$t('storage.text_37'),"tabs":_vm.cloudEnvOptions,"current-tab":_vm.cloudEnv},on:{"update:currentTab":function($event){_vm.cloudEnv=$event},"update:current-tab":function($event){_vm.cloudEnv=$event}}}),_c('page-body',[_c('list',{attrs:{"id":_vm.listId,"cloud-env":_vm.cloudEnv}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }